<template>
  <information type="discussion"></information>
</template>
<script>
import information from './components/articles'
export default {
  components: {
    information
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/movie/discussion.vue